import styled from 'styled-components'
import { SIZES } from '../../../constants'
import Link from '../../utils/Link'

export default styled(Link)`
  color: #333;
  display: block;
  position: relative;
  &:hover {
    color: inherit;
    text-decoration: none;
  }
  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    display: flex;
  }
`
